/**
 * @module api/authHeaders
 * @description
 *   Attach Firebase ID token to API requests so the server can identify the
 *   signed-in user even when the criticai-session cookie is missing (mobile).
 */

import { auth } from '../firebase';

/**
 * @returns {Promise<Record<string, string>>} headers to merge into fetch/axios
 */
export async function getFirebaseAuthHeaders() {
  try {
    const user = auth.currentUser;
    if (!user) {
      return {};
    }
    const token = await user.getIdToken(/* forceRefresh */ false);
    if (!token) {
      return {};
    }
    return { Authorization: `Bearer ${token}` };
  } catch (err) {
    console.warn('getFirebaseAuthHeaders failed:', err?.message || err);
    return {};
  }
}

/**
 * fetch() wrapper: credentials + Firebase Bearer token when signed in.
 *
 * @param {string} url
 * @param {RequestInit} [options]
 * @returns {Promise<Response>}
 */
export async function apiFetch(url, options = {}) {
  const authHeaders = await getFirebaseAuthHeaders();
  const headers = {
    ...(options.headers || {}),
    ...authHeaders,
  };
  return fetch(url, {
    ...options,
    credentials: options.credentials ?? 'include',
    headers,
  });
}

export default getFirebaseAuthHeaders;
